var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 770,
    height: 770,
    viewBox: "0 0 770 770",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M657.568 0H215.385L382.035 166.961C385.781 166.741 389.553 166.631 393.351 166.631C431.308 166.614 468.516 177.203 500.789 197.208C533.062 217.213 559.118 245.84 576.026 279.866C579.282 279.653 582.576 279.536 585.89 279.536C613.27 279.542 640.102 287.215 663.356 301.687C686.611 316.159 705.359 336.855 717.484 361.435L769.805 309.048V118.221C769.3 88.0165 757.484 59.1031 736.697 37.2082C715.911 15.3132 687.67 2.0337 657.568 0V0Z",
    fill: "#00B4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M717.561 361.436L504.87 574.46L692.389 762.221C714.927 753.696 734.376 738.569 748.202 718.814C762.029 699.059 769.59 675.591 769.9 651.47V308.971L717.561 361.436Z",
    fill: "#FF6E6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4588 505.216C79.791 491.287 76.8884 476.386 76.9132 461.346C76.9132 398.849 125.997 348.189 186.534 348.189C187.948 348.189 189.343 348.189 190.739 348.286C196.051 300.268 218.202 255.695 253.252 222.494C288.301 189.293 333.977 169.617 382.153 166.967L215.503 0.102539H113.092C82.6303 2.04661 54.0529 15.538 33.1738 37.8316C12.2948 60.1253 0.682691 89.5464 0.700154 120.109V590.103L85.4588 505.216Z",
    fill: "#23D3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M504.698 574.458H186.495C169.949 574.474 153.627 570.628 138.825 563.224C114.592 550.994 95.615 530.373 85.4198 505.19L0.661133 590.097V649.683C0.661133 681.588 13.319 712.186 35.8501 734.746C47.0063 745.917 60.2508 754.778 74.8271 760.823C89.4035 766.869 105.026 769.98 120.804 769.98H649.76C664.277 769.973 678.672 767.344 692.256 762.219L504.698 574.458Z",
    fill: "#00F5D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M769.3 118.221C768.797 87.9901 756.961 59.0533 736.141 37.1535C715.321 15.2538 687.039 1.99202 656.909 0L112.391 0C81.94 1.97125 53.3786 15.4709 32.5051 37.7586C11.6317 60.0464 0.0102538 89.4519 0 120.006H0V649.703C0 681.608 12.6578 712.206 35.1889 734.766C57.72 757.326 88.2788 770 120.143 770H649.157C663.674 769.994 678.07 767.365 691.653 762.239H691.789C714.328 753.716 733.779 738.59 747.605 718.835C761.432 699.079 768.992 675.61 769.3 651.488V651.488V312.928V118.221Z",
    fill: "url(#paint0_radial_5291_11139)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M718.046 361.668C705.921 337.088 687.172 316.392 663.918 301.92C640.664 287.448 613.831 279.775 586.451 279.769C583.137 279.769 579.862 279.886 576.607 280.099C559.694 246.073 533.634 217.447 501.358 197.442C469.082 177.437 431.872 166.848 393.913 166.864C390.037 166.864 386.355 166.981 382.596 167.194C334.42 169.844 288.744 189.52 253.695 222.721C218.645 255.922 196.494 300.496 191.182 348.513C189.787 348.513 188.391 348.416 186.977 348.416C126.44 348.416 77.3564 399.077 77.3564 461.573C77.3315 476.614 80.2342 491.515 85.902 505.443C96.0972 530.625 115.074 551.247 139.307 563.477C154.109 570.881 170.431 574.727 186.977 574.711H505.355L718.065 361.688L718.046 361.668Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652.469 346.941C675.271 346.61 697.835 351.627 718.354 361.59L505.566 574.614V487.437H505.759C507.46 449.615 523.658 413.906 550.983 387.738C578.309 361.57 614.658 346.958 652.469 346.941V346.941Z",
    fill: "#FFD12F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5291_11139",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(384.65 385.01) scale(384.573 385.068)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#261C38",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#261C38",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#302640",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#302640",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.a1c610e3cacb47c4bce18b58caf62a01.svg";